import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Opp-List-Nav" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "App-Opp-List-C" }
const _hoisted_4 = {
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_5 = { style: {"margin-top":"-2px"} }
const _hoisted_6 = { "mute-primary": "" }
const _hoisted_7 = { style: {"margin-top":"-3px"} }
const _hoisted_8 = { "mute-secondary": "" }
const _hoisted_9 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_Bulb = _resolveComponent("Bulb")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      loading: _ctx.loading,
      rows: 5,
      animated: ""
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_space, {
          fill: "",
          "w-100": "",
          size: 12
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (opp) => {
              return _createVNode(_component_el_skeleton_item, {
                key: `skele${opp}`,
                variant: "p",
                style: {"width":"50%"}
              })
            }), 64))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.opportunities.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_app_section_divider, { content: "Opportunities" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Bulb)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_space, {
                fill: "",
                "w-100": "",
                size: 12
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (opp) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: `opp-nav-${opp}`,
                      to: `/opportunities/${opp._id}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, {
                            class: "App-Icon",
                            style: {"font-size":"30px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CircleCheck)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", _hoisted_4, _toDisplayString(opp.outcome), 1),
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.capitalize(opp.skill[0])) + " / " + _toDisplayString(_ctx.$filters.capitalize(opp.skill[1])), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_space, {
                                wrap: "",
                                size: 10
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.$moment(opp.startDate).format("D MMM yy")), 1),
                                  _cache[0] || (_cache[0] = _createElementVNode("span", null, "-", -1)),
                                  _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.$moment(opp.endDate).format("D MMM yy")), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}